import { ArrearReport } from "../../../../../core";

export const arrearReport = {
    searchText: '',
    sort: true,
    dialogHability: true,
    filter: false,
    paginator: true,
    checkbox: false,
    export: true,
    exportAllData: true,
    exportFile: 'reporte_atraso.xlsx',
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Sucursal actual',
        name: 'currentEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.currentEntityName
      },
       {
        title: 'Sucursal de venta',
        name: 'saleEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: ArrearReport) => element.saleLocationName
      },
      {
        title: 'Sucursal de origen',
        name: 'originEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: ArrearReport) => element.originEntity
      },
      {
        title: 'Sucursal final',
        name: 'finalEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: ArrearReport) => element.deliveryEntity
      },
      {
        title: 'Fecha planificada de picking',
        name: 'plannedPickingDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.deliveryDate
      },
      {
        title: 'Fecha real de picking',
        name: 'realPickingDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.pendingDispatch
      },
      {
        title: 'Fecha planificada de despacho',
        name: 'plannedDispatchDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.deliveryDate
      },
      {
        title: 'Fecha real de despacho',
        name: 'realDispatchDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.deliveredDate
      },
      {
        title: 'N/V',
        name: 'nvCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.saleNoteId
      },
      {
        title: 'Código de despacho',
        name: 'dispatchCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.dispatchId
      },
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.skuCode + '-' + element.skuPartialSequence.toString()
      },
      {
        title: 'LPN',
        name: 'lpn',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: false,
        class: 'center',
        value: (element: ArrearReport) => element.lpn
      },
      {
        title: 'Descripción',
        name: 'productDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.skuName.replace('�', '')
      },
      {
        title: 'División de producto',
        name: 'productDivision',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.productItem && element.productItem.hierarchyDetail ? element.productItem.hierarchyDetail.divisionDescription : ''
      },
      {
        title: 'Área de producto',
        name: 'productArea',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.productItem && element.productItem.hierarchyDetail ? element.productItem.hierarchyDetail.areaDescription : ''
      },
      {
        title: 'Departamento de producto',
        name: 'productDepartment',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.productItem && element.productItem.hierarchyDetail ? element.productItem.hierarchyDetail.departmentDescription : ''
      },
      {
        title: 'Línea de producto',
        name: 'productLine',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.productItem && element.productItem.hierarchyDetail ? element.productItem.hierarchyDetail.lineDescription : ''
      },
      {
        title: 'Cantidad solicitada',
        name: 'requestedAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.originalCreationAmount
      },
      {
        title: 'Cantidad ejecutada',
        name: 'processedAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.processedAmount
      },
      {
        title: 'Cantidad pendiente',
        name: 'pendingAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.pendingAmount
      }
      /* {
        title: 'Primera entidad con atraso',
        name: 'firstEntityArrear',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ArrearReport) => element.firstEntityArrear
      } */
    ]
  }